export const GA_TRACKING_ID = process.env.GA_ID
export const GTM_ID = process.env.GTM_ID

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = url => {
  try {
    ;(window as any).gtag('config', GA_TRACKING_ID, {
      page_path: url
    })
  } catch (error: any) {
    // TODO: Add error handling or proper logging
    // eslint-disable-next-line no-console
    console.error(error)
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value = null }) => {
  try {
    ;(window as any).gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    })
  } catch (error: any) {
    // TODO: Add error handling or proper logging
    // eslint-disable-next-line no-console
    console.error(error)
  }
}
